import restCrudReducer from '../../../np-crud/store/restCrudReducer';

const [crudInitialState, crudReducer] = restCrudReducer({
    pluginName: 'STATISTIC',
    entityName: 'OVERVIEW',
});

const initialState = {
    ...crudInitialState,
    overviews: {
        display: 0, erasedStorages: 0, failedStorages: 0, hdd: 0,
        mobile: 0, pc: 0, shreddedStorages: 0, ssd: 0, storage: 0, totalStorages: 0
    }
};
const reducer = (state = initialState, action) => {
    // Handle CRUD actions
    const newState = crudReducer(state, action);
    // If CRUD reducer handled the action
    if (newState !== null) {
        return newState;
    }

    // Handle other actions
    switch (action.type) {
        case 'STATISTIC|STATISTIC_OVERVIEW_SUCCESS':
            return { ...state, overviews: action.data };
        case 'CORE|LOGOUT_SUCCESS':
        case 'CORE|CORE_SET_ACTIVE_CUSTOMER_SUCCESS':
            return initialState;
        default:
            return state;
    }
};

export default reducer;
